// Fórmula de Haversine para calcular distância em km
function haversineDistance(lat1: number, lon1: number, lat2: number, lon2: number) {
    const toRad = (x: any) => (x * Math.PI) / 180;

    const R = 6371; // raio da Terra em km
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

function findClosestLocation(currentLat: number, currentLon: number, locations: any) {
    return locations?.reduce((closest: any, loc: any) => {
        const distance = haversineDistance(
            currentLat,
            currentLon,
            loc.coordinates?.latitude,
            loc.coordinates?.longitude
        );

        return !closest || distance < closest.distance
            ? { ...loc, distance }
            : closest;
    }, null);
}

export {findClosestLocation}

